import apiClient from "./index";
import { invalidateMembersCache } from "./members";

export const login = async (phoneNumber, password) => {
  return apiClient.post("/auth/login", {
    phone_number: phoneNumber,
    password: password,
  });
};

// 전화번호(로그인 아이디) 변경 — 고객 토큰 필요(인터셉터가 자동 부착)
export const changePhone = async (newPhoneNumber, password) => {
  try {
    const response = await apiClient.post("/auth/change-phone", {
      new_phone_number: newPhoneNumber,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("❌ 전화번호 변경 실패:", error.response?.data?.message || error.message);
    throw error;
  }
};

export const signupUser = async ({ name, phone, birth }) => {
  try {
    const response = await apiClient.post("/auth/signup", {
      name,
      phone_number: phone,
      birth,
    });
    // 매장 PC에서 대리 가입 직후 POS 회원 선택에 바로 보이도록 캐시 무효화
    invalidateMembersCache();
    return response.data;
  } catch (error) {
    console.error("❌ 회원가입 실패:", error.message);
    throw error;
  }
};